/**
 * Type Compiler
 *
 * Compiles ArkType scope from DomainDefinition type declarations.
 * Merges platform primitives with domain types.
 */

import { scope, type Module } from "arktype";

/**
 * Platform domain core primitives — shared across all domains.
 * These are automatically available in all compiled scopes.
 */
export const domainPrimitives = {
  /** Non-empty string identifier */
  NonEmptyString: "string > 0",
  /** ISO 8601 timestamp string */
  Timestamp: "string",
} as const;

/**
 * @deprecated Use `domainPrimitives` instead. Renamed for platform-wide usage.
 */
export const biblePrimitives = domainPrimitives;

/**
 * Compile ArkType types from a domain definition's type declarations.
 *
 * Merges core primitives with domain-specific types into a single
 * ArkType scope, producing a Module with validators for each type.
 *
 * @param types - Type definitions from DomainDefinitionJSON.types
 * @returns Compiled ArkType Module
 */
export function compileTypes(types: Record<string, unknown>): Module {
  return scope({
    ...domainPrimitives,
    ...types,
  }).export();
}
